import { ref, watch, computed, onMounted } from 'vue'
import { defineStore } from 'pinia'
import { useStorage } from 'vue3-storage'

const storage = useStorage()

export const useCartStore = defineStore("cart",()=>{

    const cart = ref([])
    const show_modal = ref(false)
    const last_added = ref(null)
    const cartAvailable = ref(false)



    function add(product_id,article_id,qt,modal=true){
        let item = cart.value.find(item => item.article_id == article_id)
        if(item){
            item.qt += qt

        }else{
            cart.value.push({product_id,article_id,qt})
        }
        last_added.value = {product_id,article_id,qt}
        show_modal.value = modal
    }

    const qtTotal = computed(()=>{
        return cart.value.reduce((acc,item)=>{
            return acc + item.qt
        },0)
    })

    function clearCart(){
        cart.value = []
    }

    onMounted(()=>{
        const storedCart = storage.getStorage({key:"cart"})
            .then((result)=>{
                cart.value = result.data
                cartAvailable.value = true
            })
            .catch(()=>{
                cart.value = []
                cartAvailable.value = true
            })
    })

    watch(cart,(value)=>{
        storage.setStorage({key:"cart",data:value})
    },{deep:true})

    return {
        cartAvailable,
        cart,
        add,
        qtTotal,
        show_modal,
        last_added,
        clearCart
    }

})